export const DividerVertical = ({className}) => {
  return (
    <div className={`${className} border-start border-light `} 
    style={{width: "1px" }}></div>
  );
};